import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'

export const RoleRoutes = [
  {
    path: '/roles',
    name: 'ListRoles',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'role:list'
    }
  },
  {
    path: '/role/',
    name: 'CreateRole',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'role:create'
    }
  },
  {
    path: '/role/:id',
    name: 'UpdateRole',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'role:update'
    }
  },
  {
    path: '/role/view/:id',
    name: 'GetRole',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'role:get'
    }
  }
]
